import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "departure_board__search" }
const _hoisted_2 = { class: "departure-search" }
const _hoisted_3 = { class: "departure-search__form" }
const _hoisted_4 = { class: "departure-search__bar" }
const _hoisted_5 = {
  for: "f-search",
  class: "show-for-sr"
}
const _hoisted_6 = { class: "departure-search__controls" }
const _hoisted_7 = ["placeholder", "title"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-close-small" })
], -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", { class: "btn__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-button-arrow" })
], -1 /* HOISTED */)

import { inject, ref } from 'vue'
import { AppSettingsKey } from './../../types/keys'
import type { AppSettings } from '../../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartureSearch',
  emits: ["onDepartureSearch", "onSearchCleared"],
  setup(__props, { emit: __emit }) {

const isSearching = ref<boolean>(false)
const searchTerm = ref<string>('')
const { resourceStrings } = inject(AppSettingsKey) as AppSettings

const emit = __emit

function onSearch(): void {
  if (searchTerm.value) {
    isSearching.value = true
    emit('onDepartureSearch', searchTerm.value)
  }
}

function onClear(): void {
  searchTerm.value = ''
  isSearching.value = false
  emit('onSearchCleared')
}

function handleInput(): void {
  if (!searchTerm.value) {
    onClear()
  }
}

function handleInputBlur(): void {
  if (!searchTerm.value) {
    onClear()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(resourceStrings)['TravelUpdates.Labels.Sr.Search']), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
              onKeyup: _withKeys(onSearch, ["enter"]),
              onInput: handleInput,
              onBlur: handleInputBlur,
              "data-departure-board-search": "",
              class: "departure-search__input",
              type: "text",
              id: "f-search",
              name: "departure-search",
              autocomplete: "off",
              placeholder: 
                _unref(resourceStrings)['TravelUpdates.Placeholders.EnterBoardingCode']
              ,
              title: _unref(resourceStrings)['TravelUpdates.Labels.Sr.Search']
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
              [_vModelText, searchTerm.value]
            ]),
            (isSearching.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: onClear,
                  class: "departure-search__button departure-search__button--clear",
                  "aria-label": _unref(resourceStrings)['TravelUpdates.Buttons.Clear']
                }, _hoisted_10, 8 /* PROPS */, _hoisted_8))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              onClick: onSearch,
              class: "btn btn--sm btn--vt-key departure-search__button"
            }, [
              _createTextVNode(_toDisplayString(_unref(resourceStrings)['TravelUpdates.Buttons.Search']) + " ", 1 /* TEXT */),
              _hoisted_11
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})